export function isSampled(samplingRate = 1.0, internal = false) {
  const randomValue = Math.random() % 100;

  return randomValue < samplingRate * 100 || internal;
}
